import { gql } from "@apollo/client";

export const ChatSessionMessageReactionFragment = gql`
  fragment ChatSessionMessageReactionFragment on ChatSessionMessageReactionNode {
    id
    reactionType
    messageId
    comment
    creator {
      id
      firstName
      lastName
    }
  }
`;

export const CitationFragment = gql`
  fragment CitationFragment on AnswerCitationNode {
    url
    title
    sourceId
    sourceProvider
    sourceType
    meeting {
      id
      meetingGroupId
      title
      startDatetime
    }
    assessment {
      id
      submittedDatetime
      responder {
        id
        name
        avatar
      }
      template {
        assessmentType
      }
      target {
        id
      }
    }
  }
`;

export const AskAiChatMessageFragment = gql`
  fragment AskAiChatMessageFragment on ChatMessageNode {
    id
    content
    imageUrls
    role
    autogenerated
    error
    isStreaming
    toolCalls {
      toolName
      resultCount
      arguments
      output
    }

    createdArtifact {
      id
    }
  }
`;

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  query getAskAiChatSessionQuery($chatSessionId: Int!) {
    chatSession(chatSessionId: $chatSessionId) {
      id
      updated
      assessment {
        id
        target {
          id
          name
        }
      }
      assessmentQuestion {
        id
        title
      }
      meeting {
        id
        title
      }
      reactions {
        edges {
          node {
            ...ChatSessionMessageReactionFragment
          }
        }
      }
      messages {
        edges {
          node {
            ...AskAiChatMessageFragment
          }
        }
      }
    }
  }
`;
